/**
 * Star Graphic Mode for the TSP100 series, including TSP100IIILAN.
 * The printer's native page is a raster: enter raster, one row at a time, then quit.
 * Quitting runs the end-of-page action, which feeds the slip out and cuts.
 */

const ESC = 0x1b

export function canvasToStarGraphic(canvas: HTMLCanvasElement): Uint8Array {
    const context = canvas.getContext('2d', { willReadFrequently: true })
    if (!context) throw new Error('Could not get canvas context')
    const width = canvas.width
    const height = canvas.height
    const bytesPerRow = Math.ceil(width / 8)
    const { data } = context.getImageData(0, 0, width, height)

    const header = Uint8Array.from([
        ESC, 0x2a, 0x72, 0x41,
        ESC, 0x2a, 0x72, 0x50, 0x30, 0x00,
        ESC, 0x2a, 0x72, 0x45, 0x39, 0x00,
    ])
    const footer = Uint8Array.from([ESC, 0x2a, 0x72, 0x42])
    const rowBytes = 3 + bytesPerRow
    const body = new Uint8Array(height * rowBytes)

    for (let y = 0; y < height; y++) {
        const offset = y * rowBytes
        body[offset] = 0x62
        body[offset + 1] = bytesPerRow & 0xff
        body[offset + 2] = (bytesPerRow >> 8) & 0xff
        const rowStart = offset + 3
        for (let x = 0; x < width; x++) {
            if (data[(width * y + x) * 4] < 200) {
                body[rowStart + (x >> 3)] |= 1 << (7 - (x & 7))
            }
        }
    }

    const out = new Uint8Array(header.length + body.length + footer.length)
    out.set(header, 0)
    out.set(body, header.length)
    out.set(footer, header.length + body.length)
    return out
}
